window.addEventListener('DOMContentLoaded', function() {
  $('.t4s-main-article-page h2').each(function(index) {
    $(this).attr('id', 'untitled_' + index);
    $('ul#itemNav').append('<li id="li' + index + '">' + $(this).text() + '</li>');
  });

  $('ul#itemNav li').on('click', function() {
    var ind = $(this).index();
    $('html,body').animate(
      {
        scrollTop: $('.t4s-main-article-page h2#untitled_' + ind).offset().top - 120,
      },
      100
    );
  });

  if ($(window).width() > 640) {
    $(window).on('scroll', function() {
      $('.t4s-main-article-page h2').each(function() {
        var targetOffset = parseInt($(this).offset().top - $(window).scrollTop() - 120, 10);
        var targetId = $(this).attr('id');
        var index = targetId.split('_')[1];
        if (targetOffset <= 0) {
          $('ul#itemNav li').removeClass('on');
          $('ul#itemNav li#li' + index).addClass('on');
        }
      });
    });
  }
});
